export const surveyStatus = {
  INIT: 'init',
  SUBMIT: 'submit',
  FIRST_DISMISS: 'first-dismiss',
  SECOND_DISMISS: 'second-dismiss',
  THIRD_DISMISS: 'third-dismiss',
  FOURTH_DISMISS: 'fourth-dismiss',
};
